export const EXPORT_FIELDS_CUMULATIVE_REPORT = [
  {
    index: '0',
    source: 'periods',
    label: 'Периоды',
  },
  {
    index: '1',
    source: 'currency',
    label: 'Валюта',
  },
  {
    index: '2',
    source: 'deposits',
    label: 'Пополнения',
  },
  {
    index: '3',
    source: 'withdrawals',
    label: 'Выводы',
  },
  {
    index: '4',
    source: 'refunds',
    label: 'Рефанды',
  },
  {
    index: '5',
    source: 'chargebacks',
    label: 'Чарджбеки',
  },
  {
    index: '6',
    source: 'commissionDeposits',
    label: 'Комиссия за пополнения',
  },
  {
    index: '7',
    source: 'commissionWithdrawals',
    label: 'Комиссия за выводы',
  },
  {
    index: '8',
    source: 'commissionRefunds',
    label: 'Комиссия за рефанды',
  },
  {
    index: '9',
    source: 'commissionChargebacks',
    label: 'Комиссия за чарджбеки',
  },
  {
    index: '10',
    source: 'totalForPeriod',
    label: 'Итого за период',
  },
  {
    index: '11',
    source: 'cumulativeTotal',
    label: 'Нарастающий итог',
  },
];
